export enum FilterType {
  Checkbox = 'checkbox',
  SelectDropdown = 'selectDropdown',
}

// Interface inferred from returned objects.
export type SelectOption = {
  label: string;
  value: string | null;
  leadingIcon?: string;
  leadingIconType?: 'component';
};
